export default __webpack_public_path__ + "static/media/bolg.d7c991a5.png";